import {
  Backend,
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { isDefined } from '@freelancer/utils';
import {
  CommentFeedUpdateActionType,
  CommentFeedUpdatePayload,
} from './comment-feeds.backend-model';
import { CommentFeed, ExtraCommentFeedContext } from './comment-feeds.model';
import { CommentFeedsCollection } from './comment-feeds.types';

export function commentFeedsBackend(): Backend<CommentFeedsCollection> {
  return {
    defaultOrder: {
      field: 'timeUpdated',
      direction: OrderByDirection.DESC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: `messages/0.1/comment_feeds/`,
      isGaf: false,
      params: {
        context_ids: getQueryParamValue(query, 'contextId'),
        context_type: getQueryParamValue(query, 'contextType')[0],
      },
    }),
    push: (
      authUid,
      commentFeed: CommentFeed,
      extra?: ExtraCommentFeedContext,
    ) => ({
      endpoint: `messages/0.1/comment_feeds/`,
      payload: {
        comment_feed: {
          message: {
            message: (commentFeed.comment && commentFeed.comment.comment) || '',
            message_source:
              commentFeed.comment && commentFeed.comment.commentSource,
          },
          context: {
            id: commentFeed.contextId,
            type: commentFeed.contextType,
          },
          thread_type: commentFeed.threadType,
        },
        text_entities: extra?.textEntities
          ?.filter(isDefined)
          .map(textEntity => ({
            reference_type: textEntity.referenceType,
            reference_id: textEntity.referenceId,
            offset: textEntity.offset,
            length: textEntity.length,
            content: textEntity.content,
          })),
      },
    }),
    set: undefined,
    update: (authUid, commentFeed, originalCommentFeed) => {
      let payload: CommentFeedUpdatePayload | undefined;

      if (commentFeed.timeRead !== undefined) {
        payload = {
          comment_feeds: [originalCommentFeed.id],
          action: CommentFeedUpdateActionType.READ,
        };
      }

      if (!payload) {
        throw new Error('Update payload is empty.');
      }

      return {
        endpoint: 'messages/0.1/comment_feeds/',
        asFormData: true,
        payload,
        method: 'PUT',
      };
    },
    remove: undefined,
  };
}
